import { Box, TextField, TextFieldProps } from "@mui/material";
import { useField } from "formik";
import React from "react";

import FieldErrorFeedbackFormatter from "components/forms/FieldErrorFeedbackFormatter";
import type { MakeRequired } from "utils/types";

import FormikLabel from "../FormikLabel";

type Props = MakeRequired<TextFieldProps, "name">;

const FormikTextField = ({ label, name, helperText, ...rest }: Props) => {
  const [field, meta] = useField<unknown>(name);

  let helperTextValue;
  if (helperText !== false) {
    helperTextValue =
      meta.touched && meta.error ? (
        <FieldErrorFeedbackFormatter error={meta.error} />
      ) : (
        helperText
      );
  }

  return (
    <Box>
      <FormikLabel>{label}</FormikLabel>
      <TextField
        label=""
        fullWidth
        error={meta.touched && !!meta.error}
        helperText={helperTextValue}
        {...field}
        {...rest}
      />
    </Box>
  );
};

export default FormikTextField;
